<template>
  <section id="trip" class="trip section-show" style="height: auto!important;">
    <div class="container crewmate">
      <div class="row mt-2">

        <div class="col-lg-5 crewmate__photo">
          фото куратора
        </div>

        <div class="col-lg-7 crewmate__info">
          описание куратора
        </div>

      </div>
    </div>
  </section>
</template>

<script lang="ts">
import {defineComponent} from "vue";

export default defineComponent({
  name: 'RiderProfilePage',
  components: {},
  setup: function () {
    return {}
  },
})
</script>

<style scoped>
</style>
